<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card tile>
        <v-card-title>Connect Shopify to RedChirp</v-card-title>

        <v-card-text>
            <!-- Step 1 requires special styling -->
            <v-card
                flat
            >
                <v-card-title class="pb-2">
                    <v-icon
                        color="primary"
                        left
                    >
                        mdi-numeric-1-circle
                    </v-icon>

                    <span class="text-subtitle-1">Find RedChirp in the Shopify App Store</span>
                </v-card-title>

                <v-card-text>
                    <v-btn
                        color="primary"
                        outlined
                        href="https://apps.shopify.com/redchirp"
                        target="_blank"
                    >
                        Install on Shopify App Store
                        <v-icon
                            right
                        >
                            mdi-open-in-new
                        </v-icon>
                    </v-btn>
                </v-card-text>
            </v-card>
            
            <v-card
                v-for="(step, index) in instructions"
                :key="'step-' + index"
                flat
            >
                <v-card-title class="pb-2">
                    <v-icon
                        color="primary"
                        left
                    >
                        {{ step.icon }}
                    </v-icon>

                    <span class="text-subtitle-1">{{ step.title }}</span>
                </v-card-title>

                <v-card-text>
                    {{ step.body }}
                </v-card-text>
            </v-card>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="primary darken-1"
                text
                @click="onClose"
            >
            Close
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            instructions: [
                {
                    'icon': 'mdi-numeric-2-circle',
                    'title': 'Click "Install"',
                    'body': 'On the RedChirp app\'s detail page, click the prominent "Install" button. You will be directed to the authorization page in RedChirp.',
                },
                {
                    'icon': 'mdi-numeric-3-circle',
                    'title': 'Install Shopify in RedChirp',
                    'body': 'After verifying that you are logged into the correct RedChirp organization, click the "Connect Shopify" button. You will be directed to a page in Shopify to grant necessary permissions.'
                },
                {
                    'icon': 'mdi-numeric-4-circle',
                    'title': 'Authorize RedChirp and Complete Onboarding',
                    'body': "After confirming the app installation in the Shopify Admin panel, you will be redirected back here to the Organization Settings > Integrations page in RedChirp.",
                },
                {
                    'icon': 'mdi-numeric-5-circle',
                    'title': 'Enable Shopify Integration',
                    'body': "In the Shopify settings dialog (click on the 'Shopify' card), enable the integration.",
                },
                {
                    'icon': 'mdi-check-all',
                    'title': "That's it!",
                    'body': "Once the integration in enabled, RedChirp will start syncing data automatically from your Shopify store.",
                },
            ]
        }
    },

    methods: {

        showDialog()
        {
            this.dialog = true;
        },

        onClose()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>